<template>
    <!-- 石化采购意向单 -->
  <div>
    <div class="container">
      <ESearch
              :data="listQuery"
              :field-list="fieldList"
              :list-type-info="listTypeInfo"
              :width="width"
              @handleFilter="handleSearch"
              @handleReset="handleClear"
      />
    </div>
    <div class="plan-tips">
      <p><span>提示：</span>
        供应商须通过订单关联、库存信息关联、成品原材料信息录入的方式与石化采购意向单（包括框架协议订货函、中选通知或中标通知）进行关联。</p>

    </div>
    <div class="container">
      <div class="handle-wrapper flex-sb">
        <div>
          <eui-btn @click="createTime">接收时间排序</eui-btn>
          <eui-icon icon="eicon-r-l-zhishijiantouzhuangtaishangjiantou" :class="{ 'my-icon': isDown }"></eui-icon>
        </div>
        <eui-btn @click="ecPurchasePlanExport">导出</eui-btn>
      </div>
      <TableList :table-data="tableData" index-show :loading="loading" :table-label="tableLabel">
        <template #handle="{ scope: { row } }">
          <eui-btn type="link" font-size="12px" @click.native.prevent="openDrawer(row)">关联原材料/零部件</eui-btn>
          <eui-btn type="link" font-size="12px" @click.native.prevent="viewDetail(row)">查看石化意向单详情</eui-btn>
          <eui-btn type="link" font-size="12px" @click.native.prevent="viewRawMaterialDetail(row)">查看已关联信息详情</eui-btn>
        </template>
        <template #purchaseList="{ scope: { row } }">
          <template v-if="row.purchaseList.length === 1">
            <eui-btn type="link" font-size="12px" @click="goToDetail(row)">
              {{ dealNo(row.purchaseList) }}
            </eui-btn>
          </template>
          <template v-else>
            <eui-btn type="link" font-size="12px" @click="goToDetail(row)">
              {{ dealNo(row.purchaseList) }}
            </eui-btn>
            <eui-btn v-if="row.purchaseList.length > 1" type="link" font-size="12px" @click="openDialog(row)">
              查看更多
            </eui-btn>
          </template>
        </template>
        <template #remark="{ scope: { row, $index } }">
          <el-tooltip class="item" effect="dark" placement="top-start" :disabled="!row.remark">
            <div slot="content">
              {{ row.remark }}
            </div>
            <div class="remark-content" :class="{ 'remark-color': row.remark }" @click="openRemark(row, $index)">
              {{ row.remark ? row.remark : '支持填写企业内部编号' }}
            </div>
          </el-tooltip>
        </template>
          <template #available="{ scope: { row, $index } }">
              <div>
                <span v-if="row.available === 1">是</span>
                  <eui-btn v-if="row.available === 1" class="margin-l10" type="link" font-size="12px"
                           @click="viewAvailable(row.id)">
                      查看详情
                  </eui-btn>
              </div>
          </template>
      </TableList>
      <div class="pagination">
        <el-pagination
          :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="listQuery.pageNum"
          :page-size="listQuery.pageSize"
          :total="total"
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
      <OrderDrawer
              :visible.sync="drawerVisible"
              :purchase-plan-id="purchasePlanId"
              :availableParent="available"
              @refresh="getList(listQuery)"/>
    <OrderDialog :visible.sync="dialogVisible" :purchase-list="purchaseList" />
    <EDialog
      dialog-title="备注"
      :center-dialog-visible.sync="remarkVisible"
      popup-width="520px"
      :close-model="false"
      @resetPopupData="onCancel"
      @submitPopupData="onSubmit"
    >
      <div class="plan-tips">
        <p><span>提示：</span>
            支持企业内部单号，用于石化采购意向单与企业内部单号关联，例如填写企业生产令号、ERP单号等。
        </p>
      </div>
      <div class="flex">
        <div style="width: 50px;">备注：</div>
        <el-input
                v-model="dialogRemark"
                type="textarea"
                placeholder="请输入备注信息"
                :maxlength="300"
                show-word-limit
        ></el-input>
      </div>

    </EDialog>
      <!-- 现货查看详情-->
      <available-dialog
              v-if="availableVisible"
              :availableVisible.sync="availableVisible"
              :purchasePlanId="purchasePlanId"
      />
    <!--查看详情-->
    <MaterialsDialog
            :visible.sync="materialsVisible"
            :purchase-plan-id="purchasePlanId"></MaterialsDialog>

  </div>
</template>

<script>
import MaterialsDialog from '../stockOrder/components/MaterialsDialog.vue';
import ESearch from '@/modules/projectA/components/common/e-search';
import TableList from '@/modules/projectA/components/common/e-table-list.vue';
import EDialog from '@/modules/projectA/components/common/e-dialog.vue';
import api from '@/modules/projectA/api/order';
import _ from 'lodash';
import { epecMallUrl } from '@/modules/projectA/api/config';
import { fieldList, listTypeInfo, tableLabel, getPurchaseList } from '../common/purchasingPlan';
import OrderDrawer from './components/OrderDrawer.vue';
import OrderDialog from './components/OrderDialog.vue';
import utils from '@/modules/projectA/utils/utils';
import availableDialog from './components/availableDialog';

export default {
  components: {
    TableList,
    ESearch,
    OrderDrawer,
    OrderDialog,
    EDialog,
    availableDialog,
    MaterialsDialog
  },
  props: {},
  data() {
    return {
      materialsVisible: false,
      fieldList,
      listTypeInfo,
      width: {
        labelWidth: 130,
        itemWidth: 220,
      },
      listQuery: {
        stockAffirmId: '',
        stockAffirmName: '',
        dataType: '',
        createDateBegin: '',
        createDateEnd: '',
        stockType: '',
        available: '',
        linked: '',
        pageNum: 1,
        pageSize: 10,
        orderByCreateTime: 1,
      },
      total: 0,
      cloneListQuery: {},
      tableData: [],
      loading: false,
      tableLabel,
      drawerVisible: false,
      available: '',
      purchasePlanId: 0,
      purchaseList: [],
      dialogVisible: false,

      isDown: false,
      remarkVisible: false,
      index: -1,
      dialogRemark: '',
      availableVisible: false,

    };
  },
  created() {
    this.cloneListQuery = _.cloneDeep(this.listQuery);
    this.getList(this.listQuery);
  },
  methods: {
    async ecPurchasePlanExport() {
      const res = await api.ecPurchasePlanExport(this.listQuery);
      if (res.type == 'application/json') {
        utils.fileExportResponseError(res);
      } else {
        utils.downFile(res, '石化采购意向单信息');
      }
    },
    dealNo(val) {
      if (val.length > 0) {
        return val[0].stockNo ? val[0].stockNo : val[0].orderNo;
      }
      return '';
    },
    onCancel() {
      this.remarkVisible = false;
      this.dialogRemark = '';
    },
    async onSubmit() {
      const { index, dialogRemark: remark, purchasePlanId } = this;
      const res = await api.ecPurchasePlanModify({ purchasePlanId, remark });
      if (res.code === '200') {
        this.$message.success('备注成功');
        this.$set(this.tableData[index], 'remark', remark);
        this.onCancel();
      }
    },
    getPurchaseList,
    createTime() {
      ('1:升序；2：降序');

      this.listQuery.orderByCreateTime = this.listQuery.orderByCreateTime === 1 ? 2 : 1;
      this.isDown = !this.isDown;
      this.listQuery.pageNum = 1;
      this.getList(this.listQuery);
    },
    goToDetail(row) {
      const {stockId, orderId} = row.purchaseList[0];
      if (orderId) {
        window.open(
                `${epecMallUrl}/materialPurchasingOrder?orderId=${orderId}&orderFlag=orderDetail&flag=canHandle`,
                '_blank'
        );
      } else {
        this.$router.push({
          name: 'StockDetail',
          params: {
            id: stockId,
          },
        });
      }
    },
    viewAvailable(id) {
      this.availableVisible = true;
      this.purchasePlanId = id;
    },
    openRemark(row, index) {
      this.remarkVisible = true;
      this.index = index;
      const { remark = '', id } = row;
      this.dialogRemark = remark;
      this.purchasePlanId = id;
    },
    openDialog(row) {
      this.purchaseList = this.getPurchaseList(row);
      this.dialogVisible = true;
    },
    //查看原材料详情
    viewRawMaterialDetail(row) {
      const {stockAffirmId, id} = row;
      this.$router.push({name: 'rawMaterialDetail', query: {stockAffirmId, type: '1', id}});
    },
    viewDetail(row) {
      this.purchasePlanId = row.id;
      this.materialsVisible = true;
    },
    openDrawer(row) {
      const {id, available} = row;
      this.purchasePlanId = id;
      this.drawerVisible = true;
      this.available = String(available);
    },
    async getList(params) {
      try {
        const { ecPurchasePlanQueryPage } = api;
        this.loading = true;
        const { code, data = {} } = (await ecPurchasePlanQueryPage(params)) || {};
        if (code === '200') {
          const { records = [], total = 0 } = data;
          records.forEach((element) => {
            element.purchaseList = this.getPurchaseList(element) || [];
          });
          this.tableData = [...records];
          this.total = total;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    handleCurrentChange(val) {
      this.listQuery.pageNum = val;
      this.getList(this.listQuery);
    },
    handleSizeChange(val) {
      this.listQuery.pageNum = 1;
      this.listQuery.pageSize = val;
      this.getList(this.listQuery);
    },
    handleSearch(val) {
      this.listQuery = { ...val };
      if (val.createTime?.length) {
        const [startTime, endTime] = val.createTime;
        this.listQuery.createDateBegin = startTime;
        this.listQuery.createDateEnd = endTime;
      } else {
        this.listQuery.createDateBegin = '';
        this.listQuery.createDateEnd = '';
      }
      this.listQuery.pageNum = 1;
      this.getList(this.listQuery);
    },
    handleClear() {
      this.listQuery = {
        ...this.cloneListQuery,
      };
      this.getList(this.listQuery);
    },
  },
};
</script>

<style scoped lang="scss">
.my-icon {
  transform: rotate(180deg);
}
.down {
  transition: transform 0.6s;
}
.plan-tips {
  padding: 15px 10px;
  background: #e8efff;
  margin-bottom: 10px;
  span {
    color: #f0250f;
  }
}
.remark-content {
  height: 28px;
  line-height: 28px;
  color: rgb(220, 223, 230);
  border: 1px solid rgb(220, 223, 230);
  border-radius: 4px;
  padding: 0 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.remark-content.remark-color {
  color: #333;
}
</style>
